import autoBind from 'react-autobind';
import {CommunityLessonPlans} from '../components';
import {connect} from 'react-redux';
import Divider from 'material-ui/Divider';
import {Filter} from '../../shared/components';
import {Map} from 'immutable';
import {withRouter} from 'react-router';

import {
  getDisplayableShortGrade,
  handleApiError,
} from '../../shared/services';


import {
  loadCommunityLessonPlans,
  loadFilters,
  updateCommunityFilters,
} from '../actions';

import {MainContent, Page, PageBody, PageHeader, SideNavigationBar} from '../../layout/components';

import React, {Component, PropTypes} from 'react';

class CommunityPage extends Component {
  constructor(props, context) {
    super(props, context);

    autoBind(this);
  }

  componentDidMount() {
    const {router} = this.props;

    this.props.loadFilters()
      .catch(error => handleApiError(error, router, 'An error occurred while attempting to load the community lesson plan filters.', 'Error'));

    this.props.loadCommunityLessonPlans()
      .catch(error => handleApiError(error, router, 'An error occurred while attempting to load the community lesson plans.', 'Error'));
  }

  displayableCommunityLessonPlans(displayableGrades) {
    const {filteredCommunityLessonPlans} = this.props;

    return displayableGrades.map(d => {
      const lessonPlans = filteredCommunityLessonPlans.get(d.get('short'));

      if (!lessonPlans || lessonPlans.size === 0) return <div key={d.get('id')} />;

      return (
        <div key={d.get('id')} className="community-lesson-plan-grade-container">
          <div className="community-lesson-plan-grade">
            <div className="community-lesson-plan-grade-title">{getDisplayableShortGrade(d.toJS()).toUpperCase()}</div>
            <CommunityLessonPlans gradeText={d.get('long')} lessonPlans={lessonPlans} />
          </div>
          <Divider />
        </div>);
    });
  }

  render() {
    const {filteredCommunityLessonPlans, filters, loading, updateCommunityFilters} = this.props;
    const gradeFilters = filters.get('grades');
    const gradeFiltersSet = gradeFilters.some(f => f.get('value'));
    const displayableGrades = gradeFilters.filterNot(f => gradeFiltersSet && !f.get('value'));
    return (
      <Page pageClassName="community-page">
        <PageHeader title="Community" />
        <PageBody>
          <SideNavigationBar />
          <MainContent loading={loading}>
            <div className="community-lesson-plans-container">
              <div className="filter-container">
                <Filter filters={filters.toJS()} onFilterRequest={updateCommunityFilters} />
              </div>
              { gradeFiltersSet || !filteredCommunityLessonPlans.get('Schoolwide') || filteredCommunityLessonPlans.get('Schoolwide').size === 0
                ? <div />
                : <div className="community-lesson-plan-grade-container">
                    <div className="community-lesson-plan-grade">
                      <div className="community-lesson-plan-grade-title">SCHOOLWIDE</div>
                      <CommunityLessonPlans gradeText="Schoolwide" lessonPlans={filteredCommunityLessonPlans.get('Schoolwide')} />
                    </div>
                    <Divider />
                  </div>
              }
              { !filteredCommunityLessonPlans.get('HomeCommunity') || filteredCommunityLessonPlans.get('HomeCommunity').size === 0
                ? <div />
                : <div className="community-lesson-plan-grade-container">
                    <div className="community-lesson-plan-grade">
                      <div className="community-lesson-plan-grade-title">PARENT/COMMUNITY MEMBER</div>
                      <CommunityLessonPlans gradeText="Home/Community" lessonPlans={filteredCommunityLessonPlans.get('HomeCommunity')} />
                    </div>
                    <Divider />
                  </div>
              }
              { this.displayableCommunityLessonPlans(displayableGrades) }
            </div>
          </MainContent>
        </PageBody>
      </Page>
    );
  }
}

CommunityPage.propTypes = {
  filteredCommunityLessonPlans: PropTypes.instanceOf(Map).isRequired,
  filters: PropTypes.instanceOf(Map).isRequired,
  loadCommunityLessonPlans: PropTypes.func.isRequired,
  loadFilters: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  router: PropTypes.object.isRequired,
  updateCommunityFilters: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  const {showCommunityLessonPlans} = state.features.community.pages;

  return {
    filteredCommunityLessonPlans: showCommunityLessonPlans.get('filteredCommunityLessonPlans'),
    filters: showCommunityLessonPlans.get('filters'),
    loading: showCommunityLessonPlans.get('loading'),
  };
}

export default withRouter(connect(
  mapStateToProps,
  {
    loadCommunityLessonPlans,
    loadFilters,
    updateCommunityFilters,
  }
)(CommunityPage));



// WEBPACK FOOTER //
// ./app/features/community/components/CommunityPage.js